export default __webpack_public_path__ + "static/media/Chat-Numbers-System-15.9de8a962.svg";